import { Modal } from '@ethsign/ui';

import { ColorAlertIcon } from '../Icons';

export const DeleteSignerModal = ({
  onConfirm,
  onCancel,
  open,
  onOpenChange
}: {
  open: boolean;
  onOpenChange: (v: boolean) => void;
  onConfirm: () => void;
  onCancel: () => void;
}) => {
  return (
    <Modal
      className="md:w-[433px]"
      open={open}
      onOpenChange={onOpenChange}
      onConfirm={onConfirm}
      onCancel={onCancel}
      confirmButtonProps={{
        variant: 'primary'
      }}
      confirmText="Delete"
    >
      <div className="flex items-center flex-col justify-center">
        <ColorAlertIcon />
        <div className="text-lg text-center font-medium text-gray-900 mt-[20px]">
          Are you sure you want to delete this signing party?
        </div>
        <div className="text-sm text-gray-500 mt-[8px] text-center">
          Once deleted, all the assigned fields to the party will be deleted from the contract template as well.
        </div>
      </div>
    </Modal>
  );
};
